<div class="quick-invoice-container">

  <!-- ── Header ─────────────────────────────────────────────────────────── -->
  <div class="qi-header">
    <div class="qi-header-left">
      <mat-icon class="qi-header-icon">flash_on</mat-icon>
      <div>
        <h4 class="qi-title">Nuova Fattura rapida</h4>
        <span class="qi-subtitle">N. {{ progressiveNumber }} per {{ selectedCompany?.company_name ? selectedCompany?.company_name : '-'}}</span>
      </div>
    </div>
    <div class="qi-header-actions">
      <button
        mat-icon-button
        (click)="expandToFullInvoice()"
        [disabled]="isSubmitting"
        matTooltip="Apri come fattura completa"
      >
        <mat-icon>open_in_full</mat-icon>
      </button>
      <button mat-icon-button (click)="close()" [disabled]="isSubmitting">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- ── Loading iniziale ─────────────────────────────────────────────── -->
  <div *ngIf="isLoading" class="qi-loading-overlay">
    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-2">Caricamento...</p>
  </div>

  <!-- ── Form ─────────────────────────────────────────────────────────── -->
  <div class="qi-body" *ngIf="!isLoading" [formGroup]="mainForm">
    <mat-accordion multi class="qi-accordion">

    <!-- ── Sezione: Cliente e Fattura ───────────────────────────────── -->
    <mat-expansion-panel class="qi-panel" [expanded]="true" #panelClienteFattura>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="qi-panel-icon">person</mat-icon>
          Dati
        </mat-panel-title>
        <mat-panel-description>
          Num. {{ progressiveNumber ? progressiveNumber : 'n' }}/{{ enumeration ? enumeration : 'Anno' }}
          <span class="panel-state">{{ panelClienteFattura.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-form-field appearance="outline" class="qi-full-width">
        <mat-label>Cerca cliente</mat-label>
        <input
          matInput
          [formControl]="companySearchControl"
          [matAutocomplete]="companyAuto"
          placeholder="Nome o partita IVA..."
        />
        <mat-icon matSuffix *ngIf="!selectedCompany">search</mat-icon>
        <button
          matSuffix
          mat-icon-button
          *ngIf="selectedCompany"
          (click)="clearCompany()"
          matTooltip="Rimuovi cliente"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete
          #companyAuto="matAutocomplete"
          [displayWith]="displayCompany.bind(this)"
          (optionSelected)="onCompanySelected($event.option.value)"
        >
          <mat-option
            *ngFor="let company of filteredCompanies$ | async"
            [value]="company"
          >
            <span class="company-name">{{ company.company_name }}</span>
            <span class="company-vat" *ngIf="company.iva_number">
              &nbsp;·&nbsp;{{ company.iva_number }}
            </span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <div *ngIf="selectedCompany" class="qi-selected-company">
        <mat-icon>check_circle</mat-icon>
        <span>
          {{ selectedCompany.company_name }}
          <ng-container *ngIf="selectedCompany.iva_number">
            &nbsp;·&nbsp;P.IVA {{ selectedCompany.iva_number }}
          </ng-container>
          <ng-container *ngIf="!selectedCompany.iva_number && selectedCompany.c_f">
            &nbsp;·&nbsp;C.F. {{ selectedCompany.c_f }}
          </ng-container>
        </span>
      </div>

      <!-- Due colonne: a sinistra i dati della fattura, a destra i toggle cartacea -->
      <div class="qi-cliente-fattura-columns mt-3">
        <div class="qi-cliente-fattura-col">
          <div class="qi-fields-row">
            <mat-form-field appearance="outline" class="qi-field-half">
              <mat-label>Numero progressivo</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="progressiveNumber"
                [ngModelOptions]="{ standalone: true }"
                matTooltip="Numero progressivo della fattura. Ricorda che in questo campo la sequenza numerica deve essere progressiva (es. 1, 2, 3...), senza salti o numeri ripetuti. Il 1° gennaio di ogni anno, la numerazione riparte da 1!"
                required
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="qi-field-half">
              <mat-label>Numerazione</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="enumeration"
                [ngModelOptions]="{ standalone: true }"
                matTooltip="La numerazione è importante. Ricorda di indicare in questo campo l'anno di riferimento, prestando attenzione all'ultimo numero progressivo già inserito in precedenza."
                required
              />
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="qi-full-width">
            <mat-label>Codice ATECO</mat-label>
            <mat-select
              [(ngModel)]="selectedAtecoCodeId"
              [ngModelOptions]="{ standalone: true }"
              matTooltip="Seleziona il codice ATECO di riferimento fra quelli disponibili."
            >
              <mat-option *ngIf="atecoCodes.length === 0" disabled>
                Nessun codice ATECO disponibile
              </mat-option>
              <mat-option
                *ngFor="let atecoCode of atecoCodes"
                [value]="atecoCode.id"
              >
                {{ atecoCode.ateco_division }}.{{ atecoCode.ateco_class }}.{{ atecoCode.ateco_subcategory }} - {{ atecoCode.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="qi-full-width">
            <mat-label>Causale della fattura</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="4"
              formControlName="description"
              placeholder="Es. Prestazione professionale mese di giugno..."
            ></textarea>
            <mat-error *ngIf="mainForm.get('description')?.hasError('required')">
              La causale è obbligatoria
            </mat-error>
          </mat-form-field>
        </div>

        <div class="qi-cliente-fattura-col">
          <h5 class="qi-col-subtitle">
            <mat-icon class="qi-panel-icon">print</mat-icon>
            Fatturazione cartacea
          </h5>
          <div class="qi-withholdings-grid">
            <div class="qi-withholding-row">
              <mat-slide-toggle
                [(ngModel)]="isPaperInvoice"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onPaperInvoiceToggleChange()"
                color="primary"
                matTooltip="Se attivi questa opzione, la fattura non verrà emessa come fattura elettronica, ma solo come cartacea."
              >
                Fattura solo cartacea
              </mat-slide-toggle>
            </div>

            <div class="qi-withholding-row">
              <mat-slide-toggle
                [(ngModel)]="isHealthcareInvoice"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onHealthcareToggleChange()"
                color="primary"
                matTooltip="Fattura per prestazione sanitaria. Queste fatture non vengono inoltrate allo SDI (sono fatture solo cartacee)."
              >
                Fattura prestazione sanitaria
              </mat-slide-toggle>
            </div>
          </div>

          <h5 class="qi-col-subtitle">
            <mat-icon class="qi-panel-icon">approval</mat-icon>
            Bollo
          </h5>
          <div class="qi-withholdings-grid">
            <div class="qi-withholding-row">
              <mat-slide-toggle
                [checked]="revenueStampOption === 'customer'"
                (change)="onRevenueStampCustomerToggle($event.checked)"
                color="primary"
              >
                Bollo a carico del cliente
              </mat-slide-toggle>
              <span class="qi-amount-preview" *ngIf="revenueStampOption === 'customer'">
                +€ {{ formatCurrency(invoiceRevenueStamp) }}
              </span>
            </div>

            <div class="qi-withholding-row">
              <mat-slide-toggle
                [checked]="revenueStampOption === 'me'"
                (change)="onRevenueStampMeToggle($event.checked)"
                color="primary"
              >
                Marca da bollo a tuo carico
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>

      <!-- Fatturazione: metodo di pagamento, data di emissione, termini di
           pagamento e codice destinatario -->
      <h5 class="qi-col-subtitle mt-3">
        <mat-icon class="qi-panel-icon">payments</mat-icon>
        Fatturazione
      </h5>
      <div class="qi-billing-fields-row">
        <mat-form-field appearance="outline" class="qi-billing-field">
          <mat-label>Metodo di pagamento</mat-label>
          <mat-select
            [(ngModel)]="paymentMethod"
            [ngModelOptions]="{ standalone: true }"
            matTooltip="Qui indichi come preferisci essere pagato/a."
          >
            <mat-option
              *ngFor="let method of paymentMethodOptions"
              [value]="method.code"
            >
              {{ method.code }} - {{ method.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="qi-billing-field">
          <mat-label>Data di emissione</mat-label>
          <input
            matInput
            type="date"
            [(ngModel)]="emissionDate"
            [ngModelOptions]="{ standalone: true }"
            matTooltip="La data di emissione della fattura."
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="qi-billing-field">
          <mat-label>Termini di pagamento (giorni)</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="paymentDays"
            [ngModelOptions]="{ standalone: true }"
            min="0"
            max="1000"
            matTooltip="Fra quanti giorni vuoi che il tuo cliente paghi? L'App calcolerà la data di pagamento (prevista) in automatico."
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="qi-billing-field">
          <mat-label>Codice destinatario</mat-label>
          <input
            matInput
            [(ngModel)]="addresseeCode"
            [ngModelOptions]="{ standalone: true }"
            required
            minlength="6"
            maxlength="7"
            pattern="^[A-Z0-9]*"
            matTooltip="Questo è il codice SDI del tuo cliente. Viene impostato in automatico in base alla tua anagrafica, ma puoi eventualmente modificarlo qui."
            #addresseeCodeInput="ngModel"
          />
          <mat-error *ngIf="addresseeCodeInput.invalid && (addresseeCodeInput.dirty || addresseeCodeInput.touched)">
            Il Codice SDI deve essere composto esattamente da 6 o 7 caratteri alfanumerici maiuscoli
          </mat-error>
        </mat-form-field>

        <!-- Forza l'IBAN su una nuova riga (desktop), largo due campi -->
        <div class="qi-billing-row-break"></div>

        <mat-form-field appearance="outline" class="qi-billing-field qi-billing-field--iban">
          <mat-label>IBAN</mat-label>
          <input
            matInput
            [(ngModel)]="iban"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="validateIban()"
            [pattern]="'^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{11,30}$'"
            matTooltip="Indica un IBAN sul quale desideri ricevere il pagamento, se il metodo di pagamento scelto lo prevede."
          />
          <mat-error *ngIf="!isValidIban">
            IBAN non valido. Formato: AA00XXXXXXXXXXXXXXXXXXXXXXX
          </mat-error>
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <!-- ── Sezione: Prodotti ────────────────────────────────────────── -->
    <mat-expansion-panel class="qi-panel" #panelPrestazioni>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="qi-panel-icon">inventory_2</mat-icon>
          Prestazioni
        </mat-panel-title>
        <mat-panel-description>
          Aggiunte: <span class="article-badge">{{ productLines.length }}</span>
          <span class="panel-state">{{ panelPrestazioni.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <!-- Voci già aggiunte (card, stile new-invoice) -->
      <mat-card
        *ngFor="let line of productLines; let i = index"
        class="mb-2 product-card"
      >
        <mat-card-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              {{ line.name }} - {{ line.quantity }} {{ line.units }} <br />
              <strong>€ {{ formatCurrency(line.lineTotal) }}</strong>
              <p *ngIf="line.description" class="text-muted qi-line-description">
                <i>{{ line.description }}</i>
              </p>
            </div>
            <button
              mat-icon-button
              color="warn"
              (click)="removeProductLine(i)"
              type="button"
              matTooltip="Rimuovi voce"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Autocomplete prestazioni salvate -->
      <p class="qi-add-line-hint">Cerca fra le prestazioni salvate:</p>
      <mat-form-field appearance="outline" class="qi-full-width">
        <mat-label>Cerca prestazione</mat-label>
        <input
          matInput
          [formControl]="newProductNameControl"
          [matAutocomplete]="productAuto"
          placeholder="Nome prestazione..."
        />
        <mat-autocomplete
          #productAuto="matAutocomplete"
          [displayWith]="displayProduct.bind(this)"
          (optionSelected)="onSavedProductSelected($event.option.value)"
        >
          <mat-option
            *ngFor="let product of filteredNewProducts$ | async"
            [value]="product"
          >
            {{ product.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Oppure nuova voce -->
      <p class="qi-add-line-hint">Oppure aggiungi un nuovo prodotto/servizio:</p>

      <div class="qi-product-line">
        <mat-form-field appearance="outline" class="qi-full-width">
          <mat-label>Nome voce</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="4"
            [(ngModel)]="newProductLine.name"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Nome del prodotto o servizio..."
            matTooltip="Il nome della prestazione che vuoi inserire in fattura. Puoi scriverlo liberamente, anche senza selezionarlo dalle prestazioni salvate."
          ></textarea>
        </mat-form-field>

        <div class="qi-product-numbers">
          <!-- Quantità -->
          <mat-form-field appearance="outline" class="qi-quarter">
            <mat-label>Qtà</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="newProductLine.quantity"
              [ngModelOptions]="{ standalone: true }"
              min="1"
              (ngModelChange)="calculateNewLineTotal()"
            />
          </mat-form-field>

          <!-- Unità di misura -->
          <mat-form-field appearance="outline" class="qi-quarter">
            <mat-label>Unità</mat-label>
            <input
              matInput
              [(ngModel)]="newProductLine.units"
              [ngModelOptions]="{ standalone: true }"
              placeholder="pz, ore..."
            />
          </mat-form-field>

          <!-- Prezzo unitario -->
          <mat-form-field appearance="outline" class="qi-quarter">
            <mat-label>Prezzo (€)</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="newProductLine.gross_amount"
              [ngModelOptions]="{ standalone: true }"
              min="0"
              step="0.01"
              (ngModelChange)="calculateNewLineTotal()"
            />
          </mat-form-field>

          <!-- Sconto -->
          <mat-form-field appearance="outline" class="qi-quarter">
            <mat-label>Sconto %</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="newProductLine.discount"
              [ngModelOptions]="{ standalone: true }"
              min="0"
              max="100"
              (ngModelChange)="calculateNewLineTotal()"
            />
          </mat-form-field>
        </div>

        <div class="qi-description-total-row">
          <mat-form-field appearance="outline" class="qi-description-field">
            <mat-label>Descrizione (opzionale)</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="4"
              [(ngModel)]="newProductLine.description"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Dettagli aggiuntivi della prestazione..."
            ></textarea>
          </mat-form-field>

          <!-- Totale riga -->
          <div class="qi-line-total">
            <span class="qi-line-total-label">Totale</span>
            <span class="qi-line-total-amount">€ {{ formatCurrency(newProductLine.lineTotal) }}</span>
          </div>
        </div>
      </div>

      <!-- Aggiungi voce -->
      <button
        mat-stroked-button
        color="primary"
        (click)="addProductLine()"
        [disabled]="!isNewLineValid"
        class="qi-add-line-btn"
      >
        <mat-icon>add_task</mat-icon>
        Aggiungi voce
      </button>
    </mat-expansion-panel>

    <!-- ── Sezione: Contributi ──────────────────────────────────────── -->
    <mat-expansion-panel class="qi-panel" #panelContributi>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="qi-panel-icon">account_balance</mat-icon>
          Contributi
        </mat-panel-title>
        <mat-panel-description>
          Aggiunti: <span class="withholding-badge">{{ numeroContributi }}</span>
          <span class="panel-state">{{ panelContributi.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="qi-withholdings-grid">

        <!-- RIVALSA -->
        <div class="qi-withholding-row">
          <mat-slide-toggle
            [(ngModel)]="hasRivalsa"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="toggleRivalsa()"
            color="primary"
          >
            Rivalsa
          </mat-slide-toggle>
        </div>
        <div *ngIf="hasRivalsa" class="qi-contribution-details">
          <div class="qi-contribution-fields">
            <mat-form-field appearance="outline" class="qi-rate-field-wide">
              <mat-label>Percentuale (%)</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="rivalsaRate"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="100"
                step="0.01"
                (ngModelChange)="onRateChange()"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="qi-rate-field-wide">
              <mat-label>Su imponibile (%)</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="rivalsaTotalPercentage"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="100"
                step="0.01"
                (ngModelChange)="onRateChange()"
              />
            </mat-form-field>
          </div>
          <div class="qi-contribution-total">
            <span class="qi-amount-preview">€ {{ formatCurrency(rivalsaAmount) }}</span>
          </div>
        </div>

        <!-- CASSA -->
        <div class="qi-withholding-row">
          <mat-slide-toggle
            [(ngModel)]="hasCassa"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="toggleCassa()"
            color="primary"
          >
            Cassa previdenziale
          </mat-slide-toggle>
        </div>
        <div *ngIf="hasCassa" class="qi-contribution-details">
          <div class="qi-contribution-fields">
            <mat-form-field appearance="outline" class="qi-rate-field-wide">
              <mat-label>Percentuale (%)</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="cassaRate"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="100"
                step="0.01"
                (ngModelChange)="onRateChange()"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="qi-rate-field-wide">
              <mat-label>Su imponibile (%)</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="cassaTotalPercentage"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="100"
                step="0.01"
                (ngModelChange)="onRateChange()"
              />
            </mat-form-field>
          </div>

          <!-- Tipo cassa: in ordine di DOM resta dopo i campi e prima del
               totale, ma su mobile va mostrato sopra al totale (vedi
               .qi-cassa-type-field nello scss) -->
          <div class="qi-cassa-type-field">
            <mat-form-field appearance="outline" class="qi-full-width">
              <mat-label>Tipo cassa previdenziale</mat-label>
              <mat-select
                [(ngModel)]="cassaPensionFundType"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option
                  *ngFor="let fund of pensionFundOptions"
                  [value]="fund.code"
                >
                  {{ fund.code }} — {{ fund.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="qi-contribution-total">
            <span class="qi-amount-preview">€ {{ formatCurrency(cassaAmount) }}</span>
          </div>
        </div>

        <!-- RITENUTA D'ACCONTO -->
        <div class="qi-withholding-row">
          <mat-slide-toggle
            [(ngModel)]="hasRitenutaAcconto"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="toggleRitenutaAcconto()"
            color="primary"
          >
            Ritenuta d'acconto
          </mat-slide-toggle>
        </div>
        <div *ngIf="hasRitenutaAcconto" class="qi-contribution-details">
          <div class="qi-contribution-fields">
            <mat-form-field appearance="outline" class="qi-rate-field-wide">
              <mat-label>Percentuale (%)</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="ritenutaAccontoRate"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="100"
                step="0.01"
                (ngModelChange)="onRateChange()"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="qi-rate-field-wide">
              <mat-label>Su imponibile (%)</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="ritenutaAccontoTotalPercentage"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="100"
                step="0.01"
                (ngModelChange)="onRateChange()"
              />
            </mat-form-field>
          </div>
          <div class="qi-contribution-total">
            <span class="qi-amount-preview">-€ {{ formatCurrency(ritenutaAccontoAmount) }}</span>
          </div>
        </div>

        <!-- RITENUTA -->
        <div class="qi-withholding-row">
          <mat-slide-toggle
            [(ngModel)]="hasRitenuta"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="toggleRitenuta()"
            color="primary"
          >
            Ritenuta
          </mat-slide-toggle>
        </div>
        <div *ngIf="hasRitenuta" class="qi-contribution-details">
          <div class="qi-contribution-fields">
            <mat-form-field appearance="outline" class="qi-rate-field-wide">
              <mat-label>Percentuale (%)</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="ritenutaRate"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="100"
                step="0.01"
                (ngModelChange)="onRateChange()"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="qi-rate-field-wide">
              <mat-label>Su imponibile (%)</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="ritenutaTotalPercentage"
                [ngModelOptions]="{ standalone: true }"
                min="0"
                max="100"
                step="0.01"
                (ngModelChange)="onRateChange()"
              />
            </mat-form-field>
          </div>
          <div class="qi-contribution-total">
            <span class="qi-amount-preview">-€ {{ formatCurrency(ritenutaAmount) }}</span>
          </div>
        </div>

      </div>
    </mat-expansion-panel>

    </mat-accordion>
  </div><!-- /qi-body -->

  <!-- ── Riepilogo e invio (sticky bottom) ─────────────────────────────── -->
  <div class="qi-footer" *ngIf="!isLoading">

    <!-- Totali (stesso ordine del riepilogo di new-invoice) -->
    <div class="qi-totals">

      <!-- Toggle per espandere/collassare il dettaglio del riepilogo -->
      <button
        type="button"
        class="qi-totals-toggle"
        (click)="toggleTotalsDetails()"
      >
        <span>Dettagli importo</span>
        <mat-icon>{{ showTotalsDetails ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>

      <!-- Dettaglio righe, collassabile -->
      <div class="qi-totals-details" *ngIf="showTotalsDetails">
        <!-- Totale prestazioni -->
        <div class="qi-total-row">
          <span>Totale prestazioni ({{ productLines.length }} articoli):</span>
          <span>€ {{ formatCurrency(grossAmount) }}</span>
        </div>

        <mat-divider></mat-divider>
        <div class="qi-total-row">
          <span>Sconto:</span>
          <span>- € {{ formatCurrency(discountAmount) }}</span>
        </div>

        <!-- Marca da bollo -->
        <div class="qi-total-row" *ngIf="revenueStampOption === 'customer'">
          <span>Marca da bollo:</span>
          <span>+€ {{ formatCurrency(invoiceRevenueStamp) }}</span>
        </div>
        <div class="qi-total-row" *ngIf="invoiceRevenueStampOnUser">
          <span>Marca da bollo:</span>
          <span>+€ {{ formatCurrency(2) }}</span>
        </div>

        <!-- Competenze -->
        <mat-divider></mat-divider>
        <div class="qi-total-row">
          <span>Competenze:</span>
          <span>€ {{ formatCurrency(totalBase + invoiceRevenueStamp) }}</span>
        </div>

        <!-- Rivalsa -->
        <ng-container *ngIf="hasRivalsa">
          <mat-divider></mat-divider>
          <div class="qi-total-row">
            <span>Rivalsa:</span>
            <span>€ {{ formatCurrency(rivalsaAmount) }}</span>
          </div>
          <div class="qi-total-row muted">
            <span>Totale con rivalsa:</span>
            <span>€ {{ formatCurrency(totalWithRivalsa) }}</span>
          </div>
        </ng-container>

        <!-- Cassa -->
        <ng-container *ngIf="hasCassa">
          <mat-divider></mat-divider>
          <div class="qi-total-row">
            <span>Cassa:</span>
            <span>€ {{ formatCurrency(cassaAmount) }}</span>
          </div>
          <div class="qi-total-row muted">
            <span>Imponibile:</span>
            <span>€ {{ formatCurrency(totalTaxable) }}</span>
          </div>
        </ng-container>

        <!-- IVA -->
        <mat-divider></mat-divider>
        <div class="qi-total-row">
          <span>IVA:</span>
          <span>€ {{ formatCurrency(ivaAmount) }}</span>
        </div>

        <!-- Ritenuta d'acconto -->
        <ng-container *ngIf="hasRitenutaAcconto">
          <mat-divider></mat-divider>
          <div class="qi-total-row deduction">
            <span>Ritenuta d'acconto:</span>
            <span>-€ {{ formatCurrency(ritenutaAccontoAmount) }}</span>
          </div>
        </ng-container>

        <!-- Ritenuta -->
        <ng-container *ngIf="hasRitenuta">
          <mat-divider></mat-divider>
          <div class="qi-total-row deduction">
            <span>Ritenuta:</span>
            <span>-€ {{ formatCurrency(ritenutaAmount) }}</span>
          </div>
        </ng-container>
      </div>

      <!-- Avviso fattura cartacea / prestazione sanitaria -->
      <p
        class="qi-paper-invoice-notice colored-primary-text"
        *ngIf="isPaperInvoice || isHealthcareInvoice"
      >
        Questa fattura sarà solo cartacea. Non verrà emessa come fattura Elettronica.
      </p>

      <!-- Totale da incassare: sempre visibile -->
      <div class="qi-total-row grand-total">
        <span>Totale da incassare:</span>
        <span>€ {{ formatCurrency(grandTotal) }}</span>
      </div>
    </div>

    <!-- Bottoni anteprima/invio -->
    <div class="qi-submit-row">
      <button
        mat-stroked-button
        color="primary"
        class="qi-preview-btn"
        [disabled]="!isFormValid || isSubmitting || isGeneratingPreview"
        (click)="submit(true)"
      >
        <mat-progress-spinner
          *ngIf="isGeneratingPreview"
          diameter="20"
          mode="indeterminate"
          class="qi-spinner"
        ></mat-progress-spinner>
        <mat-icon *ngIf="!isGeneratingPreview">visibility</mat-icon>
        <span>{{ isGeneratingPreview ? 'Attendi...' : 'Anteprima' }}</span>
      </button>

      <button
        mat-raised-button
        class="qi-submit-btn"
        [disabled]="!isFormValid || isSubmitting || isGeneratingPreview"
        [matTooltip]="formValidationMessage"
        [matTooltipDisabled]="isFormValid"
        (click)="submit()"
      >
        <mat-progress-spinner
          *ngIf="isSubmitting"
          diameter="20"
          mode="indeterminate"
          class="qi-spinner"
        ></mat-progress-spinner>
        <mat-icon *ngIf="!isSubmitting">send</mat-icon>
        <span>{{ isSubmitting ? 'Invio in corso...' : 'Invia' }}</span>
      </button>
    </div>

  </div>

</div>
